/**
 * 分頁套件
 * https://github.com/lokyoung/vuejs-paginate
 */
import Vue from 'vue'
import Paginate from 'vuejs-paginate'

Vue.component('PaginationList', Paginate)
